import cx from 'classnames'
import * as React from 'react'

import FlowCarousel from '../../components/FlowCarousel/FlowCarousel'
import Image from '../../components/Image/Image'
import type { CtaViewModel } from '../../view-models/CtaViewModel'
import type { FlowCardViewModel } from '../../view-models/FlowCardViewModel'
import type { ImageViewModel } from '../../view-models/ImageViewModel'
import styles from './flow-style.css'

type Props = {
  items: Array<FlowCardViewModel>
  image?: ImageViewModel
  startCta: CtaViewModel
  id?: string
}

class Flow extends React.Component<Props> {
  static displayName = 'Flow'
  static defaultProps = {}

  render() {
    const { items, image, startCta, id } = this.props

    return (
      <div className={cx(styles.flow, image ? styles.withAvatar : '')} id={id || ''}>
        {image && (
          <div className={styles.absolute}>
            <Image {...image} defaultAspect={150 / 150} />
          </div>
        )}

        <FlowCarousel items={items} startCta={startCta} />
      </div>
    )
  }
}

export default Flow